
import * as angular from "angular";

import { MapService } from "@services/map.service";

import "./veriMapPopup.scss";
import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";

interface IVeriMapPopupBindings {

    veriMap: IVeriMapComponent;

    show: boolean;
    position: google.maps.LatLng;
}

class VeriMapPopupComponentController implements angular.IComponentController, IVeriMapPopupBindings {
    veriMap: IVeriMapComponent;

    show = false;
    showPopup = false;

    position: google.maps.LatLng;
    point: google.maps.Point;
    showFromBottom = false;

    popupHideTimeout: angular.IPromise<any>;

    static $inject = ["$element", "$timeout", "mapService"];

    constructor(
        private $element: JQLite,
        private $timeout: angular.ITimeoutService,
        private mapService: MapService) {
    }

    $onInit(): void {
        //console.warn(this.$element[0], this.$element[0].offsetHeight, this.$element[0].clientHeight);       
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        if (onChangesObj["position"]) {
            if (this.position) {
                var map = this.veriMap.getMap();
                if (!map) {
                    console.warn("VeriMapPopup - no map!");

                    this.show = false;
                    this.showHidePopup();

                    return;
                }

                // We do this to ensure we have the correct height
                this.$timeout(() => {
                    this.setPopupPosition(map);
                });
            }
        }

        if (onChangesObj["show"]) {
            this.showHidePopup();
        }        
    }

    // ---------------------

    private setPopupPosition(map: google.maps.Map) {
        if (!this.position) {
            console.error("No posistion set when showing map");
            this.showPopup = false;
            return;
        }

        this.point = this.mapService.convertLatLngToPoint(this.position, map);

        var popupHeight = this.$element[0].clientHeight;
        var popupWidth = this.$element[0].clientWidth;
        var mapWidth = this.veriMap.getMap().getDiv().clientWidth;

        var popupIsTooHigh = this.point.y < popupHeight;
        var isOnLeftSide = this.point.x * 2 < mapWidth;
        var isAtExtremes = this.point.x < popupWidth / 2 || this.point.x > mapWidth - (popupWidth / 2);

        //this.showFromBottom = this.point.y < 300;

        //this.$element.removeClass("top-arrow");
        this.$element.removeClass("bottom-arrow");
        this.$element.removeClass("right-top-arrow");
        this.$element.removeClass("left-top-arrow");

        if (popupIsTooHigh || isAtExtremes) {
            this.point.y += popupHeight;

            if (isOnLeftSide) {
                this.point.x += popupWidth / 2;
                this.point.x += 20;
                this.$element.addClass("left-top-arrow");
            }
            else {
                this.point.x -= popupWidth / 2;
                this.point.x -= 20;
                this.$element.addClass("right-top-arrow");
            }
        }
        else {
            this.$element.addClass("bottom-arrow");
        }

        this.$element[0].style["top"] = `${this.point.y}px`;
        this.$element[0].style["left"] = `${this.point.x}px`;  
    }

    private showHidePopup() {

        if (this.popupHideTimeout) {
            this.$timeout.cancel(this.popupHideTimeout);
        }

        if (this.show) {

            this.popupHideTimeout = this.$timeout(() => {
                this.showPopup = true;
                this.$element.addClass("show");
            }, 300);
        }
        else {
            this.popupHideTimeout = this.$timeout(() => {
                this.showPopup = false;
                this.popupHideTimeout = null;

                this.$element.removeClass("show");
            }, 500);
        }
    }
}

export class VeriMapPopupComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    require: { [index: string]: string; };
    transclude: boolean;

    constructor() {
        this.bindings = {
            show: "<",
            position: "<"
        };

        this.require = {
            veriMap: "^veriMap"
        };

        this.transclude = true;

        this.controller = VeriMapPopupComponentController;
        this.template = require("./veriMapPopup.html");
    }
}
